// timer.service.ts
import { Injectable } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private timer$: Observable<number>;
  private timerSubject = new Subject<number>();
  private timerActive = false;
  private readonly durationInSeconds = 182; // Set your desired duration in seconds

  startTimer(): void {
    this.timerActive = true;

    this.timer$ = timer(0, 1000).pipe(
      map((tick) => this.durationInSeconds - tick),
      takeWhile((remainingTime) => remainingTime >= 0)
    );

    this.timer$.subscribe((remainingTime) => {
      this.timerSubject.next(remainingTime);
    });
  }

  stopTimer(): void {
    this.timerActive = false;
  }

  isTimerActive(): boolean {
    return this.timerActive;
  }

  getTimer(): Observable<number> {
    return this.timerSubject.asObservable();
  }
}
